/**
 * Ajándékkereső a drawerben (IDEIGLENES változat, amíg nincs kész a külön Ajándékkereső oldal).
 *
 * A varázspálca (data-gift-finder-open) megnyit egy teljes lapos panelt a drawer fölött. A panel markupja és a
 * válaszlehetőségek a snippets/menu-drawer-finder.liquid-ból jönnek, az adat a
 * templates/collection.kk-finder-feed.liquid tömör JSON-ja.
 *
 * Működés:
 * - Az állapot csak memóriában él (a drawer minden oldalon ott van, ezért nem írjuk az URL-t).
 * - Az eredmény az 1. kérdés gyűjteményének (eladási sorrend) és a többi válasz gyűjteményeinek metszete. Ha a
 *   pontos kombinációra nincs termék, fokozatosan tágít (fontosság: alkalom > termék), és jelzi, mit tágított.
 * - Válaszadás közben a kiválasztott gyűjtemény adatát előre letölti, így az eredmény gyorsan jön.
 * - Nyitva a drawer többi része `inert` (billentyűzettel nem érhető el), Escape csak a panelt zárja be.
 * - Bezáráskor/új nyitáskor az állapot alaphelyzetbe áll.
 *
 * Mérés: Shopify.analytics.publish + dataLayer (lásd menu-drawer-analytics.js, ugyanaz a minta).
 */

const drawerDetails = document.getElementById('Details-menu-drawer-container');
const panel = document.getElementById('MenuDrawerFinder');
const sheet = drawerDetails ? drawerDetails.querySelector('.menu-drawer') : null;
const openButton = document.querySelector('[data-gift-finder-open]');

if (drawerDetails && panel && sheet && openButton) {
  init();
}

function init() {
  const collectionsUrl = panel.dataset.collectionsUrl || '/collections';
  const pageSize = Math.max(parseInt(panel.dataset.pageSize || '8', 10) || 8, 1);
  const stepPanels = [...panel.querySelectorAll('[data-step]')];
  const stepIds = stepPanels.map((el) => el.dataset.step);

  const backButton = panel.querySelector('[data-finder-back]');
  const body = panel.querySelector('[data-finder-body]');
  const progress = panel.querySelector('[data-finder-progress]');
  const progressLabel = panel.querySelector('[data-finder-progress-label]');
  const progressFill = panel.querySelector('[data-finder-progress-fill]');
  const resultsPanel = panel.querySelector('[data-results]');
  const resultsHeading = panel.querySelector('[data-results-heading]');
  const summary = panel.querySelector('[data-summary]');
  const note = panel.querySelector('[data-note]');
  const status = panel.querySelector('[data-status]');
  const grid = panel.querySelector('[data-grid]');
  const moreButton = panel.querySelector('[data-more]');
  const allLink = panel.querySelector('[data-all-link]');

  if (stepPanels.length === 0 || !resultsPanel) return;

  // stepId -> Map(kulcs -> válasz)
  const options = {};
  stepPanels.forEach((el) => {
    const map = new Map();
    el.querySelectorAll('[data-key]').forEach((button) => {
      map.set(button.dataset.key, {
        key: button.dataset.key,
        label: button.dataset.label || button.textContent.trim(),
        collection: button.dataset.collection || '',
        button,
      });
    });
    options[el.dataset.step] = map;
  });

  const formatNumber = (value) => String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let answers = {};
  let view = stepIds[0]; // egy lépés azonosítója, vagy 'results'
  let editing = false; // eredményből visszalépve: a következő válasz után vissza az eredményhez
  let isOpen = false;
  let closeTimer = 0;
  let resultsRun = 0;
  let items = [];
  let visibleCount = pageSize;
  let pendingRestore = null; // visszaállításkor: { visibleCount, scrollTop } az eredmény kirajzolása után

  // ── Mérés ──────────────────────────────────────────────────────────────

  function publish(eventName, params) {
    const payload = { ...params, tool: 'gift_finder', source: 'menu_drawer' };
    try {
      window.Shopify?.analytics?.publish?.(eventName, payload);
    } catch (_) {
      /* a mérés soha nem törheti el a menüt */
    }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...payload });
    } catch (_) {
      /* ugyanígy */
    }
  }

  // ── Nyitás / zárás ─────────────────────────────────────────────────────

  /** A panel mögötti részek (fejléc, lista, lábléc) nyitva az Ajándékkereső alatt ne legyenek elérhetők. */
  function setBackgroundInert(value) {
    [...sheet.children].forEach((child) => {
      if (child !== panel) child.inert = value;
    });
  }

  function resetState() {
    answers = {};
    view = stepIds[0];
    editing = false;
    resultsRun += 1;
  }

  /**
   * @param {{ restore?: boolean }} [options] restore: a mentett állapotból (válaszok, eredmény) nyit, nem tiszta
   *   lappal, és animáció nélkül (a drawer ilyenkor is épp nyílik, a kettő így egyszerre jelenik meg).
   */
  function openFinder({ restore = false } = {}) {
    clearTimeout(closeTimer);
    if (!restore) resetState();
    isOpen = true;
    panel.hidden = false;
    if (restore) panel.style.transition = 'none';
    void panel.offsetWidth; // reflow, hogy a becsúszás animálódjon
    panel.classList.add('menu-drawer__finder--open');
    if (restore) {
      void panel.offsetWidth;
      panel.style.transition = '';
    }
    setBackgroundInert(true);
    openButton.setAttribute('aria-expanded', 'true');
    render({ moveFocus: !restore });
    publish(restore ? 'gift_finder_restore' : 'gift_finder_open', {});
  }

  function closeFinder({ immediate = false, restoreFocus = true } = {}) {
    if (!isOpen && panel.hidden) return;
    isOpen = false;
    clearTimeout(closeTimer);
    resultsRun += 1; // a függőben lévő eredmény-betöltés eredményét eldobjuk
    panel.classList.remove('menu-drawer__finder--open');
    setBackgroundInert(false);
    openButton.setAttribute('aria-expanded', 'false');
    const finish = () => {
      panel.hidden = true;
    };
    if (immediate || reducedMotion) finish();
    else closeTimer = window.setTimeout(finish, 280);
    if (restoreFocus) openButton.focus({ preventScroll: true });
  }

  // ── Megjelenítés ───────────────────────────────────────────────────────

  function render({ moveFocus = false } = {}) {
    stepPanels.forEach((el) => {
      const active = view === el.dataset.step;
      el.hidden = !active;
      if (active) {
        options[view].forEach((option) => {
          option.button.setAttribute('aria-pressed', answers[view] === option.key ? 'true' : 'false');
        });
      }
    });
    resultsPanel.hidden = view !== 'results';

    progress.hidden = view === 'results';
    if (view !== 'results') {
      const index = stepIds.indexOf(view);
      progressLabel.textContent = `${index + 1} / ${stepIds.length}`;
      progressFill.style.width = `${((index + 1) / stepIds.length) * 100}%`;
    }

    let focusTarget;
    if (view === 'results') {
      focusTarget = resultsHeading;
      showResults();
    } else {
      focusTarget = stepPanels.find((el) => el.dataset.step === view).querySelector('.menu-drawer__finder-step-title');
      publish('gift_finder_step', { step: view, step_number: stepIds.indexOf(view) + 1 });
    }

    body.scrollTop = 0;
    if (moveFocus && focusTarget) focusTarget.focus({ preventScroll: true });
  }

  // ── Adatok ─────────────────────────────────────────────────────────────

  const feedCache = new Map();

  function fetchFeedPage(handle, page) {
    const url = `${collectionsUrl}/${encodeURIComponent(handle)}?view=kk-finder-feed&sort_by=best-selling&page=${page}`;
    // FIGYELEM: itt nem szabad Accept: application/json fejlécet küldeni, mert akkor a Shopify nem a
    // kk-finder-feed sablont rendereli, hanem a gyűjtemény saját (nehéz, más szerkezetű) JSON-ját adja vissza.
    return fetch(url).then((response) => {
      // Nem létező vagy üres gyűjtemény: üres lista, nem hiba (a kereső tágít vagy kihagyja)
      if (response.status === 404) return { pages: 1, products: [] };
      if (!response.ok) throw new Error('feed ' + response.status);
      return response.json().then((data) => {
        if (!data || !Array.isArray(data.products)) throw new Error('feed formátum');
        return data;
      });
    });
  }

  function loadFeed(handle) {
    return fetchFeedPage(handle, 1).then((first) => {
      if (!first.pages || first.pages <= 1) return first.products.filter((p) => p.a);
      const rest = [];
      for (let page = 2; page <= first.pages; page += 1) rest.push(fetchFeedPage(handle, page));
      return Promise.all(rest).then((pages) => first.products.concat(...pages.map((p) => p.products)).filter((p) => p.a));
    });
  }

  // A gyűjtemény-adatot böngésző-munkamenetenként rövid ideig megőrizzük: így a második kvízkitöltés, és
  // főleg a "Vissza a termékről" utáni visszaállítás azonnali (nem kell újra letölteni).
  const FEED_CACHE_TTL_MS = 15 * 60 * 1000;
  const FEED_CACHE_MAX_CHARS = 400000;

  function readFeedCache(handle) {
    try {
      const cached = JSON.parse(window.sessionStorage.getItem('kk-menu-feed:' + handle) || 'null');
      if (cached && Date.now() - cached.time < FEED_CACHE_TTL_MS && Array.isArray(cached.items)) return cached.items;
    } catch (_) {
      /* a gyorsítótár nem kötelező */
    }
    return null;
  }

  function writeFeedCache(handle, feedItems) {
    try {
      const serialized = JSON.stringify({ time: Date.now(), items: feedItems });
      if (serialized.length <= FEED_CACHE_MAX_CHARS) window.sessionStorage.setItem('kk-menu-feed:' + handle, serialized);
    } catch (_) {
      /* tele a tároló vagy tiltott: nem baj, marad a hálózat */
    }
  }

  function getFeed(handle) {
    if (!feedCache.has(handle)) {
      const cached = readFeedCache(handle);
      feedCache.set(
        handle,
        (cached
          ? Promise.resolve(cached)
          : loadFeed(handle).then((feedItems) => {
              writeFeedCache(handle, feedItems);
              return feedItems;
            })
        ).catch((error) => {
          feedCache.delete(handle);
          throw error;
        })
      );
    }
    return feedCache.get(handle);
  }

  function prefetch(handle) {
    if (!handle) return;
    getFeed(handle).catch(() => {
      /* az eredménynél újra próbálkozunk, és ott jelezzük a hibát */
    });
  }

  // ── Eredmény ───────────────────────────────────────────────────────────

  const selectedOption = (stepId) => options[stepId]?.get(answers[stepId]) || null;

  function setStatus(text, kind) {
    status.textContent = text;
    status.className = 'menu-drawer__finder-status' + (kind ? ` menu-drawer__finder-status--${kind}` : '');
    status.hidden = text === '';
  }

  function renderSummary() {
    summary.textContent = '';
    stepIds.forEach((id) => {
      const option = selectedOption(id);
      if (!option) return;
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'menu-drawer__finder-chip';
      chip.textContent = option.label;
      chip.dataset.editStep = id;
      chip.setAttribute('aria-label', `Módosítás: ${option.label}`);
      summary.append(chip);
    });
  }

  /**
   * A szűrők lehetséges részhalmazai fontosság szerint rendezve: előbb a legtöbb szűrőt megtartók,
   * azon belül azok, amelyek a fontosabb (korábbi) szűrőket tartják meg.
   */
  function relaxationOrder(count) {
    const masks = [];
    for (let mask = (1 << count) - 1; mask >= 0; mask -= 1) {
      let size = 0;
      let score = 0;
      for (let i = 0; i < count; i += 1) {
        if (mask & (1 << i)) {
          size += 1;
          score += 1 << (count - 1 - i);
        }
      }
      masks.push({ mask, size, score });
    }
    masks.sort((a, b) => b.size - a.size || b.score - a.score);
    return masks.map((m) => m.mask);
  }

  async function showResults() {
    const run = (resultsRun += 1);
    renderSummary();
    note.hidden = true;
    grid.textContent = '';
    moreButton.hidden = true;
    allLink.hidden = true;
    items = [];
    visibleCount = pageSize;
    setStatus('Ajándékötletek keresése…', 'loading');

    const dims = stepIds
      .map((id) => ({ id, option: selectedOption(id) }))
      .filter((d) => d.option && d.option.collection);

    if (dims.length === 0) {
      setStatus('Nézd meg az összes ajándékunkat!', '');
      allLink.href = collectionsUrl + '/all';
      allLink.hidden = false;
      return;
    }

    const base = dims[0];
    const filters = dims.slice(1);
    allLink.href = `${collectionsUrl}/${encodeURIComponent(base.option.collection)}`;

    let baseItems;
    let filterSets;
    try {
      [baseItems, ...filterSets] = await Promise.all([
        getFeed(base.option.collection),
        ...filters.map((f) => getFeed(f.option.collection)),
      ]);
    } catch (_) {
      if (run !== resultsRun) return;
      setStatus('Most nem sikerült betölteni az ajánlatokat. Próbáld újra, vagy nézd meg a teljes gyűjteményt.', '');
      allLink.hidden = false;
      return;
    }
    if (run !== resultsRun) return; // közben másik nézetre váltott a vásárló

    const constraints = filters.map((f, i) => {
      const ids = new Set(filterSets[i].map((p) => p.id));
      return { label: f.option.label, test: (p) => ids.has(p.id) };
    });

    let chosen = null;
    for (const mask of relaxationOrder(constraints.length)) {
      const kept = constraints.filter((_, i) => mask & (1 << i));
      const matched = baseItems.filter((p) => kept.every((c) => c.test(p)));
      if (matched.length > 0) {
        chosen = { matched, kept };
        break;
      }
    }

    if (!chosen) {
      setStatus('Ehhez a kereséshez most nincs elérhető ajándék. Nézd meg a teljes gyűjteményt, vagy kezdd újra más válaszokkal.', '');
      allLink.hidden = false;
      publish('gift_finder_result', { count: 0, relaxed: false, base: base.option.label });
      return;
    }

    items = chosen.matched;
    const relaxed = chosen.kept.length < constraints.length;
    if (relaxed) {
      const shown = [base.option.label, ...chosen.kept.map((c) => c.label)].join(' · ');
      note.textContent = `Erre a pontos kombinációra most nincs terméke, ezért kicsit tágítottunk. Ezeket mutatjuk: ${shown}.`;
      note.hidden = false;
    }

    setStatus(`${items.length} ajándékötlet`, '');
    allLink.hidden = false;
    renderGrid();

    // Visszaállításkor ugyanannyi termék látsszon, mint amikor a vásárló elment, és ugyanoda legyen görgetve.
    // (A kártyák magassága fix - négyzetes kép -, ezért a pozíció a képek betöltése előtt is stabil.)
    if (pendingRestore) {
      visibleCount = Math.max(pageSize, pendingRestore.visibleCount);
      renderGrid();
      body.scrollTop = pendingRestore.scrollTop;
      pendingRestore = null;
    }

    publish('gift_finder_result', {
      count: items.length,
      relaxed,
      base: base.option.label,
      answers: stepIds.map((id) => selectedOption(id)?.label || '-').join(' | '),
    });
  }

  function priceText(product) {
    const min = product.p / 100;
    const max = product.q / 100;
    return min === max ? `${formatNumber(min)} Ft` : `${formatNumber(min)} Ft-tól`;
  }

  function createCard(product, position) {
    const item = document.createElement('li');

    const link = document.createElement('a');
    link.className = 'menu-drawer__finder-card-link';
    link.href = product.u;
    link.dataset.position = String(position);

    if (product.i) {
      const image = document.createElement('img');
      image.className = 'menu-drawer__finder-card-img';
      image.src = product.i;
      image.alt = '';
      image.width = 480;
      image.height = 480;
      image.loading = 'lazy';
      link.append(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'menu-drawer__finder-card-placeholder';
      link.append(placeholder);
    }

    const title = document.createElement('span');
    title.className = 'menu-drawer__finder-card-title';
    title.textContent = product.t;

    const price = document.createElement('span');
    price.className = 'menu-drawer__finder-card-price';
    price.textContent = priceText(product);

    link.append(title, price);
    item.append(link);
    return item;
  }

  function renderGrid() {
    const start = grid.children.length;
    const end = Math.min(visibleCount, items.length);
    const fragment = document.createDocumentFragment();
    for (let i = start; i < end; i += 1) fragment.append(createCard(items[i], i + 1));
    grid.append(fragment);
    moreButton.hidden = end >= items.length;
  }

  // ── Események ──────────────────────────────────────────────────────────

  function choose(stepId, key) {
    const option = options[stepId].get(key);
    if (!option) return;
    prefetch(option.collection);
    publish('gift_finder_answer', { step: stepId, choice: option.label });
    answers = { ...answers, [stepId]: key };

    const nextUnanswered = stepIds.find((id) => !answers[id]);
    if (editing && !nextUnanswered) {
      view = 'results';
    } else {
      view = nextUnanswered || 'results';
    }
    if (view === 'results') editing = false;
    render({ moveFocus: true });
  }

  function goBack() {
    if (view === 'results') {
      // Eredményből: az utolsó kérdéshez vissza, onnan a válaszok módosíthatók
      view = stepIds[stepIds.length - 1];
      editing = true;
      render({ moveFocus: true });
      return;
    }
    const index = stepIds.indexOf(view);
    if (index <= 0) {
      closeFinder();
      return;
    }
    view = stepIds[index - 1];
    render({ moveFocus: true });
  }

  openButton.addEventListener('click', () => {
    if (isOpen) closeFinder();
    else openFinder();
  });

  panel.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const optionButton = target.closest('[data-key]');
    if (optionButton) {
      const el = optionButton.closest('[data-step]');
      if (el) choose(el.dataset.step, optionButton.dataset.key);
      return;
    }

    if (target.closest('[data-finder-back]')) {
      goBack();
      return;
    }

    if (target.closest('[data-restart]')) {
      publish('gift_finder_restart', {});
      resetState();
      render({ moveFocus: true });
      return;
    }

    const chip = target.closest('[data-edit-step]');
    if (chip) {
      view = chip.dataset.editStep;
      editing = true;
      render({ moveFocus: true });
      return;
    }

    if (target.closest('[data-more]')) {
      visibleCount += pageSize;
      renderGrid();
      publish('gift_finder_more', { shown: Math.min(visibleCount, items.length) });
      return;
    }

    // Termékre (vagy a teljes gyűjteményre) koppintva elmentjük az állapotot: ha a vásárló visszalép, az
    // eredmény ugyanott vár rá (lásd restoreFromSavedState). A mentés a navigáció ELŐTT történik.
    const cardLink = target.closest('.menu-drawer__finder-card-link');
    if (cardLink) {
      saveState();
      publish('gift_finder_product_click', { position: Number(cardLink.dataset.position || 0) });
      return;
    }

    if (target.closest('[data-all-link]')) saveState();
  });

  // ── Állapot mentése / visszaállítása ("Vissza a termékről") ────────────

  const STATE_KEY = 'kk-menu-finder-state';
  const STATE_TTL_MS = 30 * 60 * 1000;

  function saveState() {
    if (view !== 'results') return;
    try {
      window.sessionStorage.setItem(
        STATE_KEY,
        JSON.stringify({
          time: Date.now(),
          page: window.location.pathname + window.location.search,
          answers,
          visibleCount: Math.min(visibleCount, items.length),
          scrollTop: Math.round(body.scrollTop),
        })
      );
    } catch (_) {
      /* a visszaállítás nem kötelező */
    }
  }

  const currentPage = () => window.location.pathname + window.location.search;

  function readSavedState() {
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(STATE_KEY) || 'null');
      return saved && typeof saved === 'object' ? saved : null;
    } catch (_) {
      return null;
    }
  }

  function clearSavedState() {
    try {
      window.sessionStorage.removeItem(STATE_KEY);
    } catch (_) {
      /* ... */
    }
  }

  // A téma a hidratálást requestIdleCallback-kel, határidő nélkül indítja, ezért lassú oldalon sokáig is késhet
  const HYDRATION_WAIT_MS = 12000;

  /**
   * Megvárja, amíg a téma végzett a header szekció hidratálásával (a szekció `data-hydrated="true"` lesz).
   * Ha ez nem történik meg (pl. témaszerkesztő, ahol nincs hidratálás), a határidő után mégis továbbmegyünk.
   */
  function headerHydrated() {
    const section = drawerDetails.closest('.shopify-section');
    if (!section || section.dataset.hydrated === 'true') return Promise.resolve();
    return new Promise((resolve) => {
      const done = () => {
        observer.disconnect();
        window.clearTimeout(timer);
        resolve();
      };
      const observer = new MutationObserver(() => {
        if (section.dataset.hydrated === 'true') done();
      });
      observer.observe(section, { attributes: true, attributeFilter: ['data-hydrated'] });
      const timer = window.setTimeout(done, HYDRATION_WAIT_MS);
    });
  }

  /**
   * Ha a vásárló a böngésző Vissza gombjával érkezett vissza az oldalra, ahol a kvízt használta (és az oldal
   * újratöltődött, nem a gyorsítótárból jött vissza), a drawer és az Ajándékkereső eredménye újranyílik.
   *
   * A mentést NEM szabad törölni a termékoldal betöltésekor (az nem Vissza gombos betöltés, de a mentés pont
   * arra vár, hogy visszalépjenek): csak az eredeti oldalon dobjuk el, ha oda nem a Vissza gombbal érkeztek
   * (pl. a logóra kattintva), vagy ha lejárt / érvénytelen.
   */
  async function restoreFromSavedState() {
    const saved = readSavedState();
    if (!saved) return;

    if (Date.now() - saved.time > STATE_TTL_MS) {
      clearSavedState();
      return;
    }

    // Más oldal (pl. maga a termékoldal): a mentés az eredeti oldalra vár, itt nem nyúlunk hozzá
    if (saved.page !== currentPage()) return;

    const navigation = performance.getEntriesByType?.('navigation')?.[0];
    clearSavedState(); // az eredeti oldalra érkeztünk: egyszer használható, bárhogy is érkeztünk
    if (navigation?.type !== 'back_forward') return;

    // csak teljesen megválaszolt, érvényes kvízt állítunk vissza
    const valid = stepIds.every((id) => saved.answers && options[id].has(saved.answers[id]));
    if (!valid) return;

    // A drawer saját komponense (header-drawer.js) tölti be a nyitást, ezért meg kell várni, hogy kész legyen.
    // A téma a header szekciót az oldalbetöltés után újrarendereli és a meglévő DOM-ra morfolja (section-hydration.js),
    // ami a drawer minden attribútumát és a panel tartalmát a szerver üres állapotára állítja vissza: a
    // visszaállítást ezért csak a hidratálás UTÁN szabad elvégezni, különben azonnal felülíródik.
    await customElements.whenDefined('header-drawer');
    await headerHydrated();
    const summary = drawerDetails.querySelector(':scope > summary');
    if (!summary) return;
    if (!drawerDetails.open) summary.click();

    answers = { ...saved.answers };
    view = 'results';
    editing = false;
    pendingRestore = { visibleCount: saved.visibleCount, scrollTop: saved.scrollTop };
    openFinder({ restore: true });
  }

  // Ha az eredeti oldal a gyorsítótárból (bfcache) tér vissza, a drawer és a kvíz eleve úgy áll, ahogy a vásárló
  // hagyta, ezért a mentésre nincs szükség - különben egy későbbi, nem kapcsolódó Vissza gomb is felnyitná.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const saved = readSavedState();
    if (saved && saved.page === currentPage()) clearSavedState();
  });

  restoreFromSavedState();

  // Az Escape csak az Ajándékkeresőt zárja be, a drawert nem: a header-drawer.js keyup-ra zár, ezért a
  // keyup-ot itt el kell nyelni.
  panel.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      closeFinder();
    }
  });

  // A drawer bezárásakor a panel azonnal, animáció nélkül visszaáll (a következő nyitás tiszta lappal indul)
  drawerDetails.addEventListener('toggle', () => {
    if (!drawerDetails.open) closeFinder({ immediate: true, restoreFocus: false });
  });
}
